(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[59],{

/***/ 45792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ TextGridWithLogo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6277);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49423);
/* harmony import */ var _endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97700);
/* harmony import */ var _endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93636);
/* harmony import */ var _endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1401);
/* harmony import */ var _TextGridWithLogo_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46151);
/* harmony import */ var _TextGridWithLogo_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_TextGridWithLogo_module_scss__WEBPACK_IMPORTED_MODULE_3__);






var TextItem = function(param) {
    var header = param.header, text = param.text, buttonText = param.buttonText, _buttonArrow = param.buttonArrow, buttonArrow = _buttonArrow === void 0 ? true : _buttonArrow, _comingSoon = param.comingSoon, comingSoon = _comingSoon === void 0 ? false : _comingSoon, href = param.href, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_TextGridWithLogo_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["text-item"]), className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(comingSoon && (_TextGridWithLogo_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["coming-soon"])),
                children: header
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: text
            }),
            buttonText && href && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                href: href,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
                    as: "a",
                    target: "_blank",
                    rel: "noreferrer",
                    children: [
                        buttonText,
                        buttonArrow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_5__/* .ArrowIcon */ .e, {
                            width: 20,
                            height: 12
                        })
                    ]
                })
            })
        ]
    });
};
var TextGridWithLogo = function(param) {
    var headerText = param.headerText, pillText = param.pillText, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_TextGridWithLogo_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["text-grid-container"]), className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_icons__WEBPACK_IMPORTED_MODULE_6__/* .LogoIcon */ .K, {
                color: "#8478E0",
                width: 62
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_endaoment_frontend_ui_shared__WEBPACK_IMPORTED_MODULE_7__/* .Pill */ .D, {
                variation: "orange",
                size: "large",
                className: (_TextGridWithLogo_module_scss__WEBPACK_IMPORTED_MODULE_3___default().pill),
                children: pillText
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                children: headerText
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_TextGridWithLogo_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["text-grid"]),
                children: children
            })
        ]
    });
};
TextGridWithLogo.Item = TextItem;


/***/ }),

/***/ 54634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ smEinLookup/* SMEINLookup */.O; },
  "N": function() { return /* reexport */ SMStatsCard; }
});

// EXTERNAL MODULE: ./smart/smEinLookup/index.ts + 2 modules
var smEinLookup = __webpack_require__(29310);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react-query/es/index.js
var es = __webpack_require__(82066);
// EXTERNAL MODULE: ../../libs/api/src/lib/api.ts
var api = __webpack_require__(86130);
// EXTERNAL MODULE: ../../libs/ui/shared/src/lib/card/Card.tsx
var Card = __webpack_require__(56050);
// EXTERNAL MODULE: ../../libs/utils/src/lib/formatters.ts
var formatters = __webpack_require__(97022);
// EXTERNAL MODULE: ./smart/smStatsCard/SMStatsCard.module.scss
var SMStatsCard_module = __webpack_require__(8855);
var SMStatsCard_module_default = /*#__PURE__*/__webpack_require__.n(SMStatsCard_module);
;// CONCATENATED MODULE: ./smart/smStatsCard/SMStatsCard.tsx






var SMStatsCard = function() {
    var ref = (0,es.useQuery)(api/* api.GetTotalDonations.key */.h.GetTotalDonations.key, api/* api.GetTotalDonations.query */.h.GetTotalDonations.query), totalDonations = ref.data;
    var ref1 = (0,es.useQuery)(api/* api.GetTotalGrants.key */.h.GetTotalGrants.key, api/* api.GetTotalGrants.query */.h.GetTotalGrants.query), totalGranted = ref1.data;
    // TODO: Use a less data intensive endpoint (needs to be created?)
    var ref2 = (0,es.useQuery)(api/* api.GetDeployedOrgs.key */.h.GetDeployedOrgs.key, api/* api.GetDeployedOrgs.query */.h.GetDeployedOrgs.query), deployedOrgs = ref2.data;
    var ref3;
    var deployedOrgsCount = (ref3 = deployedOrgs === null || deployedOrgs === void 0 ? void 0 : deployedOrgs.length) !== null && ref3 !== void 0 ? ref3 : 0;
    var averageGrantSize = totalGranted / deployedOrgsCount;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card */.Z, {
            className: (SMStatsCard_module_default())["stats-card"],
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: (0,formatters/* getFormattedMoney */.Sy)(totalDonations)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Total Donations"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: (0,formatters/* getFormattedMoney */.Sy)(totalGranted)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Total Granted"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: (0,formatters/* getFormattedNumber */.bj)(deployedOrgsCount)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Orgs Deployed"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            children: (0,formatters/* getFormattedMoney */.Sy)(averageGrantSize)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Average Grant Size"
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./smart/smStatsCard/index.ts


;// CONCATENATED MODULE: ./smart/index.ts




/***/ }),

/***/ 29310:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* reexport */ SMEINLookup; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6277);
// EXTERNAL MODULE: ../../libs/config/src/lib/config.ts
var config = __webpack_require__(46518);
// EXTERNAL MODULE: ../../libs/ui/shared/src/lib/card/Card.tsx
var Card = __webpack_require__(56050);
// EXTERNAL MODULE: ../../libs/ui/shared/src/lib/button/Button.tsx + 1 modules
var Button = __webpack_require__(93636);
// EXTERNAL MODULE: ./smart/smEinLookup/SMEINLookup.module.scss
var SMEINLookup_module = __webpack_require__(89280);
var SMEINLookup_module_default = /*#__PURE__*/__webpack_require__.n(SMEINLookup_module);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-query/es/index.js
var es = __webpack_require__(82066);
// EXTERNAL MODULE: ../../libs/api/src/lib/api.ts
var api = __webpack_require__(86130);
;// CONCATENATED MODULE: ./smart/smEinLookup/useEINLookup.ts



var useEINLookup = function() {
    var ref = (0,react.useState)(""), lookupVal = ref[0], setLookupVal = ref[1];
    var ref1 = (0,es.useQuery)([
        api/* api.GetOrgByEin.key */.h.GetOrgByEin.key,
        lookupVal
    ], function() {
        return api/* api.GetOrgByEin.query */.h.GetOrgByEin.query(lookupVal);
    }), org = ref1.data, error = ref1.error;
    var lookup = function(ein) {
        if (ein.length <= 10) {
            ein = ein.replace(/-/g, "");
            setLookupVal(ein.length > 2 ? ein.slice(0, 2) + "-" + ein.slice(2) : ein);
        }
    };
    return {
        org: org,
        failed: !org && error,
        displayedEIN: lookupVal,
        lookup: lookup
    };
};

;// CONCATENATED MODULE: ./smart/smEinLookup/SMEINLookup.tsx






var SMEINLookup = function(param) {
    var className = param.className;
    var ref = useEINLookup(), displayedEIN = ref.displayedEIN, lookup = ref.lookup, org = ref.org, failed = ref.failed;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card */.Z, {
        className: (0,clsx_m/* default */.Z)((SMEINLookup_module_default())["ein-lookup"], className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        children: org ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "".concat(config/* config.clientBaseUrl */.v.clientBaseUrl, "/orgs/").concat(org.ein),
                            target: "_blank",
                            rel: "noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: org.name
                            })
                        }) : "Nonprofit Lookup"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: org ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "".concat(org.orgAddress ? "".concat(org.orgAddress, ", ") : "").concat(org.orgCity, ", ").concat(org.orgCity, ", ").concat(org.orgState)
                        }) : "Claim your 501(c)(3) organization to receive donated funds"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        value: displayedEIN,
                        onChange: function(e) {
                            return lookup(e.target.value);
                        },
                        placeholder: "12-3456789"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            org ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                as: "a",
                                variation: "org",
                                filled: true,
                                href: "".concat(config/* config.clientBaseUrl */.v.clientBaseUrl, "/orgs/").concat(org.ein).concat(org.claimed ? "" : "/claim"),
                                target: "_blank",
                                rel: "noreferrer",
                                className: (SMEINLookup_module_default())["ein-lookup-button"],
                                children: org.claimed ? "Go to Org" : "Claim Org"
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                as: "span",
                                variation: "org",
                                filled: true,
                                className: (SMEINLookup_module_default())["ein-lookup-button"],
                                children: failed ? "Invalid EIN" : "Enter EIN"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                as: "a",
                                variation: "fund",
                                filled: true,
                                href: "".concat(config/* config.clientBaseUrl */.v.clientBaseUrl, "/orgs"),
                                target: "_blank",
                                rel: "noreferrer",
                                className: (SMEINLookup_module_default())["ein-lookup-button"],
                                children: "Search All"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./smart/smEinLookup/index.ts



/***/ }),

/***/ 86130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ api; }
/* harmony export */ });
/* unused harmony export client */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50930);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94776);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89644);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _endaoment_frontend_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46518);
/* harmony import */ var _endaoment_frontend_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48314);






var client = axios__WEBPACK_IMPORTED_MODULE_1___default().create({
    baseURL: _endaoment_frontend_config__WEBPACK_IMPORTED_MODULE_2__/* .config.apiBaseUrl */ .v.apiBaseUrl,
    withCredentials: true,
    transformRequest: [
        function(data, headers) {
            var token = null;
            if (true) {
                token = window.localStorage.getItem(_endaoment_frontend_constants__WEBPACK_IMPORTED_MODULE_3__/* .TOKEN_STORAGE_KEY */ .MG);
            }
            // eslint-disable-next-line no-param-reassign
            if (token && headers) headers["Authorization"] = "Bearer ".concat(token);
            return data;
        }, 
    ].concat(// @ts-expect-error always array
    (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((axios__WEBPACK_IMPORTED_MODULE_1___default().defaults.transformRequest)))
});
// Simple error handling for api in dev
if (false) {}
var api = {
    // ************
    // ** Auth
    // ************
    GetAuthToken: {
        key: "GetAuthToken",
        execute: function(input) {
            return client.post("/auth", input);
        }
    },
    // ************
    // ** Me (Auth'd user)
    // ************
    GetMyFunds: {
        key: "GetMyFunds",
        execute: function() {
            return client.get("/me/funds");
        }
    },
    GetMyDonations: {
        key: "GetMyDonations",
        execute: function() {
            return client.get("/me/donations");
        }
    },
    GetMyClaims: {
        key: "GetMyClaims",
        execute: function() {
            return client.get("/me/claims");
        }
    },
    GetMe: {
        key: "GetMe",
        execute: function() {
            return client.get("/me");
        }
    },
    // ************
    // ** Funds
    // ************
    GetFeaturedFunds: {
        key: "GetFeaturedFunds",
        // @TODO: verify this - changes standard for all api calls
        /** @deprecated */ execute: function() {
            return client.get("/funds/public/featured");
        },
        query: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return client.get("/funds/public/featured");
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res.data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    },
    GetPublicFunds: {
        key: "GetPublicFunds",
        execute: function() {
            return client.get("/funds/public");
        }
    },
    GetFundByVanityUrl: {
        key: "GetFundByVanityUrl",
        execute: function(vanityUrl) {
            return client.get("/funds/vanity/".concat(vanityUrl));
        }
    },
    EstimateFundGas: {
        key: "EstimateFundGas",
        execute: function() {
            return client.get("/funds/estimate");
        }
    },
    CreateFund: {
        key: "CreateFund",
        execute: function(input) {
            return client.post("/funds", input);
        }
    },
    GetFund: {
        key: "GetFund",
        execute: function(id) {
            return client.get("/funds/".concat(id));
        }
    },
    // ************
    // ** Orgs
    // ************
    GetFeaturedOrgs: {
        key: "GetFeaturedOrgs",
        /** @deprecated */ execute: function() {
            return client.get("/orgs/featured");
        },
        query: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return client.get("/orgs/featured");
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res.data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    },
    GetDeployedOrgs: {
        key: "GetDeployedOrgs",
        /** @deprecated */ execute: function() {
            return client.get("/orgs/deployed");
        },
        query: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return client.get("/orgs/deployed");
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res.data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    },
    SearchOrgs: {
        key: "SearchOrgs",
        execute: function(searchTerm, code, itemsPerPage, offset) {
            return client.post("/orgs/search", {
                searchTerm: searchTerm,
                code: code,
                itemsPerPage: itemsPerPage,
                offset: offset
            });
        }
    },
    GetOrgByEin: {
        key: "GetOrgByEin",
        /** @deprecated */ execute: function(ein) {
            return client.get("/orgs/".concat(ein));
        },
        query: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(ein) {
                var res;
                return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!/^\d{2}-?\d{7}$/.test(ein)) {
                                _ctx.next = 6;
                                break;
                            }
                            _ctx.next = 3;
                            return client.get("/orgs/".concat(ein.replace(/-/g, "")));
                        case 3:
                            res = _ctx.sent;
                            if (!res.data) {
                                _ctx.next = 6;
                                break;
                            }
                            return _ctx.abrupt("return", res.data);
                        case 6:
                            return _ctx.abrupt("return", undefined);
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(ein) {
                return _ref.apply(this, arguments);
            };
        }()
    },
    GetOrgById: {
        key: "GetOrgById",
        execute: function(id) {
            return client.get("/orgs/id/".concat(id));
        }
    },
    EstimateOrgGas: {
        key: "EstimateOrgGas",
        execute: function() {
            return client.get("/orgs/estimate");
        }
    },
    DeployOrg: {
        key: "DeployOrg",
        execute: function(input) {
            return client.post("/orgs", input);
        }
    },
    // ************
    // ** Donations
    // ************
    GetTotalDonations: {
        key: "GetTotalDonations",
        /** @deprecated */ execute: function() {
            return client.get("/donations/total");
        },
        query: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return client.get("/donations/total");
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res.data.totalDonations);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    },
    GetDestinationDonations: {
        key: "GetDestinationDonations",
        execute: function(id) {
            return client.get("/donations/destination/".concat(id));
        }
    },
    GetMinDonation: {
        key: "GetMinDonation",
        execute: function() {
            return client.get("/donations/min");
        }
    },
    CreateDonation: {
        key: "CreateDonation",
        execute: function(input) {
            return client.post("/donations", input);
        }
    },
    // ************
    // ** Grants
    // ************
    GetTotalGrants: {
        key: "GetTotalGrants",
        /** @deprecated */ execute: function() {
            return client.get("/grants/total");
        },
        query: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return client.get("/grants/total");
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res.data.totalGrants);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    },
    GetFundGrants: {
        key: "GetFundGrants",
        execute: function(id) {
            return client.get("/grants/fund/".concat(id));
        }
    },
    GetOrgGrants: {
        key: "GetOrgGrants",
        execute: function(id) {
            return client.get("/grants/org/".concat(id));
        }
    },
    CreateGrant: {
        key: "CreateGrant",
        execute: function(input) {
            return client.post("/grants", input);
        }
    },
    // ************
    // ** Claims
    // ************
    CreateClaim: {
        key: "CreateClaim",
        execute: function(input) {
            return client.post("/claims", input);
        }
    },
    // ************
    // ** Tokens & Swap Info
    // ************
    GetTokens: {
        key: "GetTokens",
        execute: function(chainId) {
            return client.get("/tokens?chainId=".concat(chainId));
        }
    },
    GetSwapInfo: {
        key: "GetSwapInfo",
        execute: function(token, amount) {
            return client.get("/swap-info?amount=".concat(amount.toString()).concat(token.address ? "&tokenAddress=".concat(token.address) : ""));
        }
    },
    // ************
    // ** OTC Tokens & Info
    // ************
    GetOTCAddresses: {
        key: "GetOTCAddresses",
        /** @deprecated */ execute: function() {
            return client.get("/tokens/otc");
        },
        query: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var res;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return client.get("/tokens/otc");
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", res.data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    },
    // ************
    // ** ADMIN
    // ** @TODO: API currently doesn't have all admin routes inside /admin - so routes here can be intentionally missing /admin
    // ************
    AdminGetAllFunds: {
        key: "AdminGetAllFunds",
        execute: function() {
            return client.get("/admin/funds");
        }
    },
    AdminGetAllGrants: {
        key: "AdminGetAllGrants",
        execute: function() {
            return client.get("/admin/grants");
        }
    },
    AdminGetAllDonations: {
        key: "AdminGetAllDonations",
        execute: function() {
            return client.get("/admin/donations");
        }
    },
    AdminGetAllWithdrawals: {
        key: "AdminGetAllWithdrawals",
        execute: function() {
            return client.get("/admin/withdrawals");
        }
    },
    AdminGetAllClaims: {
        key: "AdminGetAllClaims",
        execute: function() {
            return client.get("/admin/claims");
        }
    },
    AdminDeployOrgs: {
        key: "AdminDeployOrgs",
        execute: function(input) {
            return client.post("/orgs/deployer", input);
        }
    },
    AdminApproveGrant: {
        key: "AdminApproveGrant",
        execute: function(input) {
            return client.patch("/grants/".concat(input.grantId, "/approve"), input);
        }
    },
    AdminRejectGrant: {
        key: "AdminRejectGrant",
        execute: function(input) {
            return client.patch("/grants/".concat(input.grantId, "/reject"), input);
        }
    },
    AdminApproveClaim: {
        key: "AdminApproveClaim",
        execute: function(id, input) {
            return client.patch("/claims/".concat(id, "/approve"), input);
        }
    },
    AdminRejectClaim: {
        key: "AdminRejectClaim",
        execute: function(id, input) {
            return client.patch("/claims/".concat(id, "/reject"), input);
        }
    },
    AdminClaimOrg: {
        key: "AdminClaimOrg",
        execute: function(id, input) {
            return client.patch("/orgs/".concat(id), input);
        }
    },
    AdminPayout: {
        key: "AdminPayout",
        execute: function(input) {
            return client.post("/withdrawals", input);
        }
    },
    AdminRequestEmail: {
        key: "AdminRequestEmail",
        execute: function(input) {
            return client.get("/admin/email", {
                params: input
            });
        }
    },
    AdminSendEmail: {
        key: "AdminSendEmail",
        execute: function(input) {
            return client.post("/admin/email/direct", input);
        }
    },
    AdminVerifyBank: {
        key: "AdminVerifyBank",
        execute: function(id) {
            return client.get("/claims/verifyBank/".concat(id));
        }
    }
};


/***/ }),

/***/ 97022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dl": function() { return /* binding */ getFormattedEIN; },
/* harmony export */   "Q5": function() { return /* binding */ getShortAddress; },
/* harmony export */   "Sy": function() { return /* binding */ getFormattedMoney; },
/* harmony export */   "_3": function() { return /* binding */ getDate; },
/* harmony export */   "bj": function() { return /* binding */ getFormattedNumber; },
/* harmony export */   "dW": function() { return /* binding */ parseHtml; }
/* harmony export */ });
/* unused harmony exports getCurrency, getNormalizedEIN, getOrgComplianceError */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50930);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86741);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24330);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_1__);



// eslint-disable-next-line no-restricted-imports



var getCurrency = function(value) {
    var fraction = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, compact = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        notation: compact ? "compact" : undefined,
        maximumFractionDigits: fraction,
        minimumFractionDigits: fraction
    });
    return formatter.format(Number(value || 0));
};
var getFormattedMoney = function(num) {
    return getCurrency(num, undefined, true).toLowerCase();
};
var numberFormatter = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 0,
    notation: "compact"
});
var getFormattedNumber = function(num) {
    return numberFormatter.format(num).toLowerCase();
};
var dateFormatter = new Intl.DateTimeFormat("en-US", {
    dateStyle: "long"
});
var getDate = function(dateStr) {
    return dateFormatter.format(new Date(dateStr));
};
var getShortAddress = function(address) {
    return address.length > 6 ? "".concat(address.slice(0, 5), "...").concat(address.slice(-3)) : address;
};
var getFormattedEIN = function(ein) {
    return "".concat(ein.slice(0, 2), "-").concat(ein.slice(2));
};
var getNormalizedEIN = function(ein) {
    return (ein || "").replace(/\D/gi, "");
};
/**
 * @param errorsString Error list spaced by ' :: ' between errors
 * @returns The first or only error extracted from `errorsString`
 * @TODO: this should be an array of errors
 */ var getOrgComplianceError = function(errorsString) {
    if (!errorsString) return "";
    var errors = errorsString.split(" :: ");
    return ORG_COMPLIANCE_ERRORS[errors[0]];
};
var parseHtml = function(html) {
    return (0,html_react_parser__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(sanitize_html__WEBPACK_IMPORTED_MODULE_1___default()(html || "", {
        allowedTags: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((sanitize_html__WEBPACK_IMPORTED_MODULE_1___default().defaults.allowedTags)).concat([
            "img"
        ]),
        allowedAttributes: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, (sanitize_html__WEBPACK_IMPORTED_MODULE_1___default().defaults.allowedAttributes)), {
            img: [
                "src",
                "alt",
                "style"
            ],
            h3: [
                "style"
            ],
            p: [
                "style"
            ],
            strong: [
                "style"
            ],
            small: [
                "style"
            ]
        })
    }));
};


/***/ }),

/***/ 46151:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"text-grid-container":"TextGridWithLogo_text-grid-container__qmqiC","rotate":"TextGridWithLogo_rotate__kLtFh","text-grid":"TextGridWithLogo_text-grid__YDEGt","pill":"TextGridWithLogo_pill___DNOu","text-item":"TextGridWithLogo_text-item__Zo2zd","coming-soon":"TextGridWithLogo_coming-soon__AfqEn","slide":"TextGridWithLogo_slide__L5i3E","dash":"TextGridWithLogo_dash__5TxVp","spin":"TextGridWithLogo_spin__iSKn3","floating":"TextGridWithLogo_floating__fGC_Z"};

/***/ }),

/***/ 89280:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ein-lookup":"SMEINLookup_ein-lookup__iZCya","ein-lookup-button":"SMEINLookup_ein-lookup-button__IxQET","slide":"SMEINLookup_slide__6hSqn","dash":"SMEINLookup_dash___5FGm","spin":"SMEINLookup_spin__x0p5J","rotate":"SMEINLookup_rotate__SjbYN","floating":"SMEINLookup_floating__aSU27"};

/***/ }),

/***/ 8855:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"stats-card":"SMStatsCard_stats-card__jrzCa","slide":"SMStatsCard_slide__47ZLe","dash":"SMStatsCard_dash__7R0Fo","spin":"SMStatsCard_spin__WYXH3","rotate":"SMStatsCard_rotate__wcy_J","floating":"SMStatsCard_floating__WwuET"};

/***/ }),

/***/ 70764:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 45158:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 58635:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 30139:
/***/ (function() {

/* (ignored) */

/***/ })

}]);